// app/javascript/controllers/mask_controller.js
// Usage:
// <%= f.text_field :property_apn,
//   data: { controller: "mask", mask_pattern_value: "apn", action: "input->mask#applyMask" } %>

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { pattern: String };

  connect() {
    this.patterns = {
      phone: "000-000-0000",
      apn: "000-000-000-000",
      account: "00-00",
      zip: "00000",
      stickerNumber: "0000",
    };

    if (this.element.value) this.applyMask();
  }

  applyMask(event) {
    const pattern = this.patterns[this.patternValue];
    if (!pattern) return;

    const el = this.element;
    const raw = el.value || "";

    // Save caret position
    const start = el.selectionStart ?? raw.length;
    const end = el.selectionEnd ?? start;

    const H = this.constructor; // static helper alias

    const startDigitIndex = H.digitsBeforeIndex(raw, start);
    const endDigitIndex = H.digitsBeforeIndex(raw, end);

    const digits = raw.replace(/\D/g, "").slice(0, H.countSlots(pattern));
    const formatted = this.formatWithTrailingSeparators(digits, pattern);

    if (el.value !== formatted) el.value = formatted;

    const inserting = (event?.inputType || "").startsWith("insert");

    const newStart = H.indexFromDigitCount(formatted, startDigitIndex, inserting);
    const newEnd = H.indexFromDigitCount(formatted, endDigitIndex, inserting);

    el.setSelectionRange(newStart, newEnd);
  }

  // --------------------
  // Formatting
  // --------------------

  formatWithTrailingSeparators(digits, pattern) {
    let out = "";
    let di = 0;

    for (let i = 0; i < pattern.length; i++) {
      const ch = pattern[i];

      if (ch === "0") {
        if (!digits[di]) break;
        out += digits[di++];
        continue;
      }

      const slotsBefore = this.constructor.countSlots(pattern.slice(0, i));
      if (di >= slotsBefore && out && out[out.length - 1] !== ch) {
        out += ch;
      }
    }

    return out;
  }

  // --------------------
  // Static helpers (pure)
  // --------------------

  static countSlots(pattern) {
    return (pattern.match(/0/g) || []).length;
  }

  static digitsBeforeIndex(str, index) {
    return (str.slice(0, index).match(/\d/g) || []).length;
  }

  static indexFromDigitCount(formatted, digitCount, skipSeparators) {
    if (digitCount <= 0) return 0;

    let seen = 0;

    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i]) && ++seen === digitCount) {
        let pos = i + 1;

        if (skipSeparators) {
          while (formatted[pos] && /\D/.test(formatted[pos])) pos++;
        }

        return pos;
      }
    }

    return formatted.length;
  }
}
